import React, { useState, useEffect, useRef, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "./video.css";
import Footer from "./Footer";
import ChatComponent from "./ChatComponent";

// 🔹 Icons Components
const MenuIcon = () => (
  <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
    <path d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z"/>
  </svg>
);

const CloseIcon = () => (
  <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
    <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
  </svg>
);

const HomeIcon = () => (
  <svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor">
    <path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z"/>
  </svg>
);

const LessonIcon = () => (
  <svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor">
    <path d="M4 6h16v2H4zm0 5h16v2H4zm0 5h10v2H4z"/>
  </svg>
);

const AssignmentIcon = () => (
  <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
    <path d="M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm2 14H7v-2h7v2zm3-4H7v-2h10v2zm0-4H7V7h10v2z"/>
  </svg>
);

const PDFIcon = () => (
  <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
    <path d="M20 2H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-8.5 7.5c0 .83-.67 1.5-1.5 1.5H9v2H7.5V7H10c.83 0 1.5.67 1.5 1.5v1zm5 2c0 .83-.67 1.5-1.5 1.5h-2.5V7H15c.83 0 1.5.67 1.5 1.5v3zm4-3H19v1h1.5V11H19v2h-1.5V7h3v1.5zM9 9.5h1v-1H9v1zM4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm10 5.5h1v-3h-1v3z"/>
  </svg>
);

const QuizIcon = () => (
  <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
    <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14z"/>
    <path d="M7 7h2v2H7zm0 4h2v2H7zm4-4h2v2h-2zm0 4h2v2h-2zm4-4h2v2h-2zm0 4h2v2h-2z"/>
  </svg>
);

const PlayIcon = () => (
  <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
    <path d="M8 5v14l11-7z"/>
  </svg>
);

const PauseIcon = () => (
  <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
    <path d="M6 19h4V5H6v14zm8-14v14h4V5h-4z"/>
  </svg>
);

const FullscreenIcon = () => (
  <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
    <path d="M7 14H5v5h5v-2H7v-3zm-2-4h2V7h3V5H5v5zm12 7h-3v2h5v-5h-2v3zM14 5v2h3v3h2V5h-5z"/>
  </svg>
);

const ExitFullscreenIcon = () => (
  <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
    <path d="M5 16h3v3h2v-5H5v2zm3-8H5v2h5V5H8v3zm6 11h2v-3h3v-2h-5v5zm2-11V5h-2v5h5V8h-3z"/>
  </svg>
);

const VolumeUpIcon = () => (
  <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
    <path d="M3 9v6h4l5 5V4L7 9H3zm13.5 3c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02zM14 3.23v2.06c2.89.86 5 3.54 5 6.71s-2.11 5.85-5 6.71v2.06c4.01-.91 7-4.49 7-8.77s-2.99-7.86-7-8.77z"/>
  </svg>
);

const VolumeOffIcon = () => (
  <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
    <path d="M16.5 12c0-1.77-1.02-3.29-2.5-4.03v2.21l2.45 2.45c.03-.2.05-.41.05-.63zm2.5 0c0 .94-.2 1.82-.54 2.64l1.51 1.51C20.63 14.91 21 13.5 21 12c0-4.28-2.99-7.86-7-8.77v2.06c2.89.86 5 3.54 5 6.71zM4.27 3L3 4.27 7.73 9H3v6h4l5 5v-6.73l4.25 4.25c-.67.52-1.42.93-2.25 1.18v2.06c1.38-.31 2.63-.95 3.69-1.81L19.73 21 21 19.73l-9-9L4.27 3zM12 4L9.91 6.09 12 8.18V4z"/>
  </svg>
);

const SkipPreviousIcon = () => (
  <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
    <path d="M6 6h2v12H6zm3.5 6l8.5 6V6z"/>
  </svg>
);

const SkipNextIcon = () => (
  <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
    <path d="M6 18l8.5-6L6 6v12zM16 6v12h2V6h-2z"/>
  </svg>
);

const ReplayIcon = () => (
  <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
    <path d="M12 5V1L7 6l5 5V7c3.31 0 6 2.69 6 6s-2.69 6-6 6-6-2.69-6-6H4c0 4.42 3.58 8 8 8s8-3.58 8-8-3.58-8-8-8z"/>
  </svg>
);

const SpeedIcon = () => (
  <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
    <path d="M20.38 8.57l-1.23 1.85a8 8 0 01-.22 7.58H5.07A8 8 0 0115.58 6.85l1.85-1.23A10 10 0 003.35 19a2 2 0 001.72 1h13.85a2 2 0 001.74-1 10 10 0 00-.27-10.44zm-9.79 6.84a2 2 0 002.83 0l5.66-8.49-8.49 5.66a2 2 0 000 2.83z"/>
  </svg>
);

const TimelineIcon = () => (
  <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
    <path d="M16 1H8C6.34 1 5 2.34 5 4v16c0 1.66 1.34 3 3 3h8c1.66 0 3-1.34 3-3V4c0-1.66-1.34-3-3-3zm-2 20h-4v-1h4v1zm3.25-3H6.75V4h10.5v14z"/>
  </svg>
);

const ProgressIcon = () => (
  <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm4.59-12.42L10 14.17l-2.59-2.58L6 13l4 4 8-8z"/>
  </svg>
);

// 🔹 دالة لجلب النسبة القديمة من API
const getOldProgressFromAPI = async (lesson_id) => {
  try {
    console.log('📥 Fetching old progress from API for video:', lesson_id);
    const token = localStorage.getItem("authToken");

    const response = await axios.get(
      `https://leader-acadmy.hwnix.com/api/video-progress/${lesson_id}`,
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        }
      }
    );
    
    if (response.data && response.data.percentage !== undefined) {
      console.log('✅ Old progress from API:', response.data.percentage, '%');
      return response.data.percentage;
    } else {
      console.log('⚠️ No progress found in API response');
      return 0;
    }
  } catch (error) {
    console.error('❌ Error fetching old progress from API:', error.message);
    
    if (error.response?.status === 404) {
      console.log('🆕 No previous progress found (404)');
      return 0;
    }
    
    return 0;
  }
};

// 🔹 دالة API لإرسال التقدم كل 10 ثواني
const sendProgressToAPI = async (lesson_id, percentage) => {
  if (!lesson_id || percentage === undefined) return;
  const token = localStorage.getItem("authToken");

  console.log('📤 Sending progress to API - Video ID:', lesson_id, 'Percentage:', Math.round(percentage));
  
  try {
    const response = await axios.post(
      'https://leader-acadmy.hwnix.com/api/video-progress',
      {
        lesson_id: parseInt(lesson_id),
        percentage: Math.round(percentage)
      },
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        }
      }
    );
    
    console.log('✅ API Response:', response.data);
    return response.data;
  } catch (error) {
    console.error('❌ API Error:', error.message);
    throw error;
  }
};

// 🔹 Security Alert Function
const showSecurityAlert = (message) => {
  const alert = document.createElement('div');
  alert.className = 'security-alert';
  alert.innerHTML = `
    <span class="alert-icon">🛡️</span>
    <div class="alert-content">
      <div class="alert-title">حماية المحتوى</div>
      <div class="alert-message">${message}</div>
    </div>
    <button class="close-alert">×</button>
  `;
  
  document.body.appendChild(alert);
  
  alert.querySelector('.close-alert').onclick = () => {
    alert.remove();
  };
  
  setTimeout(() => {
    if (alert.parentNode) {
      alert.remove();
    }
  }, 3000);
};

// 🔹 Error Boundary Component
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error("Component Error:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="error-fallback">
          <div className="error-icon">⚠️</div>
          <h4>حدث خطأ في التحميل</h4>
          <p>يرجى تحديث الصفحة</p>
          <button 
            className="retry-btn"
            onClick={() => window.location.reload()}
          >
            تحديث الصفحة
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

// 🔹 وظيفة لتحويل مدة YouTube (PT1H2M3S) إلى ثواني
const parseYouTubeDuration = (duration) => {
  const match = duration.match(/PT(\d+H)?(\d+M)?(\d+S)?/);
  
  if (!match) return 3600;
  
  const hours = (match[1] || '').replace('H', '') || 0;
  const minutes = (match[2] || '').replace('M', '') || 0;
  const seconds = (match[3] || '').replace('S', '') || 0;
  
  return (parseInt(hours) * 3600) + (parseInt(minutes) * 60) + parseInt(seconds);
};

// 🔹 Secure Video Player Component
const SecureVideoPlayer = ({ url, title, onError }) => {
  const [hasError, setHasError] = useState(false);
  const [isPlaying, setIsPlaying] = useState(false);
  const [isFullscreen, setIsFullscreen] = useState(false);
  const [isMuted, setIsMuted] = useState(false);
  const [videoReady, setVideoReady] = useState(false);
  const [currentTime, setCurrentTime] = useState(0);
  const [duration, setDuration] = useState(3600);
  const [playbackRate, setPlaybackRate] = useState(1);
  const [isDragging, setIsDragging] = useState(false);
  const [lastUpdateTime, setLastUpdateTime] = useState(Date.now());
  const [isLoadingDuration, setIsLoadingDuration] = useState(false);
  const [durationFetched, setDurationFetched] = useState(false);
  const [watchedPercentage, setWatchedPercentage] = useState(0);
  const [highestWatchedPercentage, setHighestWatchedPercentage] = useState(0);
  const [isWatching, setIsWatching] = useState(false);
  const [initialized, setInitialized] = useState(false);
  const [isLoadingProgress, setIsLoadingProgress] = useState(false);
  const [oldProgressApplied, setOldProgressApplied] = useState(false);
  
  const iframeRef = useRef(null);
  const videoContainerRef = useRef(null);
  const timelineRef = useRef(null);
  const playPauseRef = useRef(null);
  const fullscreenRef = useRef(null);
  const volumeRef = useRef(null);
  const timeIntervalRef = useRef(null);
  const apiIntervalRef = useRef(null);
  const lastSrcRef = useRef("");

  // 🔹 دالة لتتبع التقدم في API كل 10 ثواني
  const startAPITracking = useCallback(() => {
    const lesson_id = localStorage.getItem('lesson_id');
    if (!lesson_id) {
      console.warn('⚠️ No video_id found for API tracking');
      return;
    }
    
    console.log('🚀 Starting API tracking for video:', lesson_id);
    
    sendProgressToAPI(lesson_id, watchedPercentage).catch(err => {
      console.log('Failed initial API send:', err.message);
    });
    
    if (apiIntervalRef.current) {
      clearInterval(apiIntervalRef.current);
    }
    
    apiIntervalRef.current = setInterval(() => {
      sendProgressToAPI(lesson_id, watchedPercentage).catch(err => {
        console.log('Failed periodic API send:', err.message);
      });
    }, 10000);
  }, [watchedPercentage]);

  // 🔹 إيقاف تتبع API
  const stopAPITracking = useCallback(() => {
    if (apiIntervalRef.current) {
      clearInterval(apiIntervalRef.current);
      apiIntervalRef.current = null;
      console.log('🛑 API Tracking stopped');
    }
  }, []);

  // 🔹 جلب النسبة القديمة من API
  const fetchOldProgress = useCallback(async () => {
    const lesson_id = localStorage.getItem('lesson_id');
    if (!lesson_id || initialized) return;
    
    try {
      setIsLoadingProgress(true);
      console.log('🔍 Fetching old progress for video:', lesson_id);
      
      const oldProgress = await getOldProgressFromAPI(lesson_id);
      
      if (oldProgress > 0) {
        console.log('✅ Loaded old progress from API:', oldProgress, '%');
        
        setWatchedPercentage(oldProgress);
        setHighestWatchedPercentage(oldProgress);
        
        if (duration > 0) {
          const timeFromPercentage = (oldProgress / 100) * duration;
          setCurrentTime(timeFromPercentage);
          
          setOldProgressApplied(true);
          
          showSecurityAlert(`📊 تم استعادة تقدمك السابق: ${oldProgress}% - سيستمر الفيديو من حيث توقفت`);
        }
        
        setInitialized(true);
      } else {
        setInitialized(true);
      }
      
      setIsLoadingProgress(false);
      return oldProgress;
    } catch (error) {
      console.error('Error fetching old progress:', error);
      setIsLoadingProgress(false);
      setInitialized(true);
      return 0;
    }
  }, [duration, initialized]);

  // 🔹 جلب أعلى نسبة مشاهدة محفوظة
  const getStoredWatchedPercentage = useCallback(() => {
    if (!url) return 0;
    
    try {
      const videoId = extractYouTubeId(url);
      if (!videoId) return 0;
      
      const storedData = localStorage.getItem(`video_progress_${videoId}`);
      if (storedData) {
        const parsedData = JSON.parse(storedData);
        return parsedData.percentage || 0;
      }
    } catch (error) {
      console.error("Error reading from localStorage:", error);
    }
    return 0;
  }, [url]);

  // 🔹 حفظ نسبة المشاهدة في localStorage وAPI
  const saveWatchedPercentage = useCallback(async (percentage) => {
    if (!url) return;
    
    try {
      const videoId = extractYouTubeId(url);
      if (!videoId) return;
      
      const dataToStore = {
        videoId,
        percentage: percentage,
        lastUpdated: new Date().toISOString(),
        duration: duration
      };
      
      localStorage.setItem(`video_progress_${videoId}`, JSON.stringify(dataToStore));
      
      const watchedVideos = JSON.parse(localStorage.getItem('watched_videos') || '[]');
      const existingIndex = watchedVideos.findIndex(video => video.videoId === videoId);
      
      if (existingIndex >= 0) {
        watchedVideos[existingIndex] = dataToStore;
      } else {
        watchedVideos.push(dataToStore);
      }
      
      localStorage.setItem('watched_videos', JSON.stringify(watchedVideos));
      
      // 🔹 حفظ في الـ API
      const videoIdFromLocalStorage = localStorage.getItem('video_id');
      if (videoIdFromLocalStorage) {
        try {
          await sendProgressToAPI(videoIdFromLocalStorage, percentage);
          console.log('💾 Progress saved to API successfully');
        } catch (error) {
          console.error('Failed to save to API:', error);
        }
      }
      
    } catch (error) {
      console.error("Error saving to localStorage:", error);
    }
  }, [url, duration]);

  // 🔹 Extract video ID from URL
  const extractYouTubeId = useCallback((url) => {
    if (!url) return null;
    const regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
    const match = url.match(regExp);
    return (match && match[7].length === 11) ? match[7] : null;
  }, []);

  const extractGoogleDriveId = useCallback((url) => {
    const regExp = /\/d\/([^\/]+)/;
    const match = url.match(regExp);
    return match ? match[1] : null;
  }, []);

  const extractVimeoId = useCallback((url) => {
    const regExp = /(?:vimeo\.com\/|video\/)(\d+)/;
    const match = url.match(regExp);
    return match ? match[1] : null;
  }, []);

// 🔹 Get secure video URL
const getSecureVideoUrl = useCallback((url) => {
  if (!url) return null;

  if (url.includes('youtube.com') || url.includes('youtu.be')) {
    const videoId = extractYouTubeId(url);
    if (videoId) {
      // controls=0: إخفاء شريط يوتيوب بالكامل
      // modestbranding=1: إخفاء لوجو يوتيوب
      // disablekb=1: تعطيل اختصارات الكيبورد الأصلية
      // fs=0: تعطيل زر التكبير الأصلي
      // iv_load_policy=3: إخفاء أي شروحات أو لينكات على الفيديو
      return `https://www.youtube-nocookie.com/embed/${videoId}?rel=0&modestbranding=1&controls=0&showinfo=0&enablejsapi=1&disablekb=1&fs=0&iv_load_policy=3&origin=${window.location.origin}`;
    }
  }
  
  if (url.includes('drive.google.com')) {
    const fileId = extractGoogleDriveId(url);
    if (fileId) {
      return `https://drive.google.com/file/d/${fileId}/preview`;
    }
  }
  
  if (url.includes('vimeo.com')) {
    const videoId = extractVimeoId(url);
    if (videoId) {
      return `https://player.vimeo.com/video/${videoId}?title=0&byline=0&portrait=0`;
    }
  }

  if (url.match(/\.(mp4|webm|ogg|mov|avi|wmv|flv|mkv)$/i)) {
    return url;
  }

  return url;
}, [extractYouTubeId, extractGoogleDriveId, extractVimeoId]);
  // 🔹 جلب مدة الفيديو من YouTube API
  const fetchYouTubeDuration = useCallback(async (videoId) => {
    if (!videoId || durationFetched) return;
    
    try {
      setIsLoadingDuration(true);
      
      const response = await fetch(
        `https://www.googleapis.com/youtube/v3/videos?part=contentDetails&id=${videoId}&key=AIzaSyCvHn_-z2YxKkP5u4YFbZAgQJtFj-Q7XHA`
      );
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const data = await response.json();
      
      if (data.items && data.items.length > 0) {
        const durationStr = data.items[0].contentDetails.duration;
        const seconds = parseYouTubeDuration(durationStr);
        
        console.log("YouTube Duration Fetched:", durationStr, "->", seconds, "seconds");
        setDuration(seconds);
        setDurationFetched(true);
        return seconds;
      }
    } catch (error) {
      console.error("Error fetching YouTube duration:", error);
    } finally {
      setIsLoadingDuration(false);
    }
  }, [durationFetched]);

  // 🔹 حساب النسبة المئوية للمشاهدة
  const calculateWatchedPercentage = useCallback((time) => {
    if (!duration || duration === 0) return 0;
    
    const percentage = (time / duration) * 100;
    const roundedPercentage = Math.round(percentage * 10) / 10;
    
    return Math.min(roundedPercentage, 100);
  }, [duration]);

  // 🔹 تحديث نسبة المشاهدة وحفظها
  const updateWatchedPercentage = useCallback((time) => {
    if (!duration || duration === 0) return;
    
    const percentage = calculateWatchedPercentage(time);
    setWatchedPercentage(percentage);
    
    if (percentage > highestWatchedPercentage) {
      setHighestWatchedPercentage(percentage);
      
      if (percentage % 10 === 0 || percentage >= 50 || percentage === 100) {
        saveWatchedPercentage(percentage);
        
        if (percentage === 25) {
          showSecurityAlert("🎯 لقد أكملت 25% من الفيديو!");
        } else if (percentage === 50) {
          showSecurityAlert("🎯 لقد أكملت نصف الفيديو! استمر في التقدم 🚀");
        } else if (percentage === 75) {
          showSecurityAlert("🎯 لقد أكملت 75% من الفيديو! أنت على وشك الانتهاء 💪");
        } else if (percentage === 100) {
          showSecurityAlert("🎉 مبروك! لقد أكملت مشاهدة الفيديو بالكامل 🏆");
        }
      }
    }
  }, [duration, highestWatchedPercentage, calculateWatchedPercentage, saveWatchedPercentage]);

  // 🔹 استقبال رسائل من iframe
  useEffect(() => {
    const handleMessage = (event) => {
      try {
        const data = typeof event.data === 'string' ? JSON.parse(event.data) : event.data;
        
        if (data && data.info && data.info.duration) {
          console.log("Received duration from iframe:", data.info.duration);
          if (!durationFetched) {
            setDuration(data.info.duration);
            setDurationFetched(true);
          }
        }
        
        if (data && data.event === "infoDelivery" && data.info && data.info.currentTime) {
          const time = data.info.currentTime;
          setCurrentTime(time);
          
          if (oldProgressApplied) {
            updateWatchedPercentage(time);
          }
        }
        
        if (data && data.event === "infoDelivery" && data.info && data.info.playerState) {
          const isNowPlaying = data.info.playerState === 1;
          setIsPlaying(isNowPlaying);
          setIsWatching(isNowPlaying);
        }
      } catch (error) {
        // تجاهل الأخطاء في تحليل الرسائل
      }
    };

    window.addEventListener('message', handleMessage);
    
    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, [durationFetched, updateWatchedPercentage, oldProgressApplied]);

  // 🔹 جلب مدة الفيديو والنسبة القديمة عند تحميل الكومبوننت
  useEffect(() => {
    if (url && !durationFetched) {
      const videoId = extractYouTubeId(url);
      if (videoId) {
        fetchYouTubeDuration(videoId);
      }
    }
    
    if (!initialized) {
      fetchOldProgress();
    }
    
    startAPITracking();
    
    return () => {
      stopAPITracking();
    };
  }, [url, extractYouTubeId, fetchYouTubeDuration, durationFetched, startAPITracking, stopAPITracking, fetchOldProgress, initialized]);

  // 🔹 عند تغيير النسبة، تحديث API
  useEffect(() => {
    const videoId = localStorage.getItem('video_id');
    if (videoId && watchedPercentage > 0 && initialized) {
      sendProgressToAPI(videoId, watchedPercentage).catch(err => {
        console.log('Failed to update API on percentage change:', err.message);
      });
    }
  }, [watchedPercentage, initialized]);

  // 🔹 Simulate time progression when playing
  useEffect(() => {
    if (isPlaying && oldProgressApplied) {
      const startTime = Date.now();
      const startVideoTime = currentTime;
      
      timeIntervalRef.current = setInterval(() => {
        const elapsedSeconds = (Date.now() - startTime) / 1000;
        const newTime = startVideoTime + (elapsedSeconds * playbackRate);
        
        if (newTime >= duration) {
          setCurrentTime(duration);
          setIsPlaying(false);
          setIsWatching(false);
          updateWatchedPercentage(duration);
          showSecurityAlert("🎉 اكتمل الفيديو!");
        } else {
          setCurrentTime(newTime);
          updateWatchedPercentage(newTime);
        }
      }, 100);
    } else {
      if (timeIntervalRef.current) {
        clearInterval(timeIntervalRef.current);
        timeIntervalRef.current = null;
      }
    }
    
    return () => {
      if (timeIntervalRef.current) {
        clearInterval(timeIntervalRef.current);
      }
    };
  }, [isPlaying, playbackRate, duration, currentTime, updateWatchedPercentage, oldProgressApplied]);

  // 🔹 Handle video seeking
  const seekTo = useCallback((newTime) => {
    const clampedTime = Math.max(0, Math.min(duration, newTime));
    setCurrentTime(clampedTime);
    setLastUpdateTime(Date.now());
    
    if (clampedTime > 0) {
      setOldProgressApplied(true);
    }
    
    updateWatchedPercentage(clampedTime);
    
    const videoId = localStorage.getItem('video_id');
    if (videoId && initialized) {
      sendProgressToAPI(videoId, calculateWatchedPercentage(clampedTime)).catch(err => {
        console.log('Failed to update API on seek:', err.message);
      });
    }
    
    try {
      if (iframeRef.current && iframeRef.current.contentWindow) {
        const seconds = Math.floor(clampedTime);
        iframeRef.current.contentWindow.postMessage(
          JSON.stringify({
            event: "command",
            func: "seekTo",
            args: [seconds, true],
            id: 2
          }),
          '*'
        );
      }
    } catch (e) {
      console.log("Cannot seek in iframe");
    }
    
    showSecurityAlert(`⏱️ تم الانتقال إلى ${formatTime(clampedTime)}`);
  }, [duration, updateWatchedPercentage, calculateWatchedPercentage, initialized]);

  // 🔹 Toggle Play/Pause
  const togglePlayPause = useCallback(() => {
    if (!videoReady) return;
    
    const newIsPlaying = !isPlaying;
    setIsPlaying(newIsPlaying);
    setIsWatching(newIsPlaying);
    
    if (newIsPlaying) {
      setOldProgressApplied(true);
    }
    
    if (newIsPlaying) {
      try {
        if (iframeRef.current && iframeRef.current.contentWindow) {
          iframeRef.current.contentWindow.postMessage(
            JSON.stringify({
              event: "command",
              func: "playVideo",
              args: "",
              id: 3
            }),
            '*'
          );
        }
      } catch (e) {
        console.log("Cannot control iframe directly");
      }
    } else {
      try {
        if (iframeRef.current && iframeRef.current.contentWindow) {
          iframeRef.current.contentWindow.postMessage(
            JSON.stringify({
              event: "command",
              func: "pauseVideo",
              args: "",
              id: 4
            }),
            '*'
          );
        }
      } catch (e) {
        console.log("Cannot control iframe directly");
      }
    }
  }, [videoReady, isPlaying]);

  // 🔹 Skip forward/backward
  const skip = useCallback((seconds) => {
    setOldProgressApplied(true);
    seekTo(currentTime + seconds);
  }, [currentTime, seekTo]);

  // 🔹 Handle timeline click/drag
  const handleTimelineClick = useCallback((e) => {
    if (!timelineRef.current || !videoReady) return;
    
    setOldProgressApplied(true);
    
    const timeline = timelineRef.current;
    const rect = timeline.getBoundingClientRect();
    const clickX = Math.max(0, Math.min(rect.width, e.clientX - rect.left));
    const percentage = clickX / rect.width;
    const newTime = percentage * duration;
    
    seekTo(newTime);
  }, [videoReady, duration, seekTo]);

  const handleTimelineMouseDown = useCallback((e) => {
    setIsDragging(true);
    setIsPlaying(false);
    setIsWatching(false);
    
    setOldProgressApplied(true);
    
    const handleMouseMove = (moveEvent) => {
      if (isDragging) {
        handleTimelineClick(moveEvent);
      }
    };
    
    const handleMouseUp = () => {
      setIsDragging(false);
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseup', handleMouseUp);
    };
    
    document.addEventListener('mousemove', handleMouseMove);
    document.addEventListener('mouseup', handleMouseUp);
  }, [isDragging, handleTimelineClick]);

  // 🔹 Format time (seconds to HH:MM:SS or MM:SS)
  const formatTime = useCallback((seconds) => {
    const hours = Math.floor(seconds / 3600);
    const mins = Math.floor((seconds % 3600) / 60);
    const secs = Math.floor(seconds % 60);
    
    if (hours > 0) {
      return `${hours}:${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
    } else {
      return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
    }
  }, []);

  // 🔹 Change playback speed
  const changeSpeed = useCallback(() => {
    const speeds = [0.5, 0.75, 1, 1.25, 1.5, 2];
    const currentIndex = speeds.indexOf(playbackRate);
    const nextIndex = (currentIndex + 1) % speeds.length;
    const newSpeed = speeds[nextIndex];
    setPlaybackRate(newSpeed);
    
    if (isPlaying && oldProgressApplied) {
      if (timeIntervalRef.current) {
        clearInterval(timeIntervalRef.current);
      }
      
      const startTime = Date.now();
      const startVideoTime = currentTime;
      
      timeIntervalRef.current = setInterval(() => {
        const elapsedSeconds = (Date.now() - startTime) / 1000;
        const newTime = startVideoTime + (elapsedSeconds * newSpeed);
        
        if (newTime >= duration) {
          setCurrentTime(duration);
          setIsPlaying(false);
          setIsWatching(false);
        } else {
          setCurrentTime(newTime);
          updateWatchedPercentage(newTime);
        }
      }, 100);
    }
    
    try {
      if (iframeRef.current && iframeRef.current.contentWindow) {
        iframeRef.current.contentWindow.postMessage(
          JSON.stringify({
            event: "command",
            func: "setPlaybackRate",
            args: [newSpeed],
            id: 5
          }),
          '*'
        );
      }
    } catch (e) {
      console.log("Cannot set playback rate in iframe");
    }
    
    showSecurityAlert(`⚡ سرعة التشغيل: ${newSpeed}x`);
  }, [playbackRate, isPlaying, currentTime, duration, updateWatchedPercentage, oldProgressApplied]);

  // 🔹 Toggle Fullscreen
  const toggleFullscreen = useCallback(() => {
    if (!document.fullscreenEnabled) {
      showSecurityAlert("وضع ملء الشاشة غير مدعوم في هذا المتصفح");
      return;
    }
    
    const videoElement = videoContainerRef.current;
    if (!videoElement) return;
    
    if (!isFullscreen) {
      if (videoElement.requestFullscreen) {
        videoElement.requestFullscreen();
      } else if (videoElement.webkitRequestFullscreen) {
        videoElement.webkitRequestFullscreen();
      } else if (videoElement.msRequestFullscreen) {
        videoElement.msRequestFullscreen();
      }
    } else {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
      }
    }
  }, [isFullscreen]);

  // 🔹 Toggle Mute/Unmute
  const toggleMute = useCallback(() => {
    if (!videoReady) return;
    
    const newMuted = !isMuted;
    setIsMuted(newMuted);
    
    try {
      if (iframeRef.current && iframeRef.current.contentWindow) {
        iframeRef.current.contentWindow.postMessage(
          JSON.stringify({
            event: "command",
            func: newMuted ? "mute" : "unMute",
            args: "",
            id: 6
          }),
          '*'
        );
      }
    } catch (e) {
      console.log("Cannot control iframe audio");
    }
  }, [videoReady, isMuted]);

  // 🔹 Listen for fullscreen changes
  useEffect(() => {
    const handleFullscreenChange = () => {
      const fullscreenElement = 
        document.fullscreenElement ||
        document.webkitFullscreenElement ||
        document.msFullscreenElement;
      
      setIsFullscreen(!!fullscreenElement);
    };

    document.addEventListener('fullscreenchange', handleFullscreenChange);
    document.addEventListener('webkitfullscreenchange', handleFullscreenChange);
    document.addEventListener('msfullscreenchange', handleFullscreenChange);

    return () => {
      document.removeEventListener('fullscreenchange', handleFullscreenChange);
      document.removeEventListener('webkitfullscreenchange', handleFullscreenChange);
      document.removeEventListener('msfullscreenchange', handleFullscreenChange);
    };
  }, []);

  // 🔹 Handle keyboard shortcuts
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.code === 'Space' && !e.target.closest('input, textarea')) {
        e.preventDefault();
        togglePlayPause();
      }
      if (e.code === 'KeyF') {
        e.preventDefault();
        toggleFullscreen();
      }
      if (e.code === 'KeyM') {
        e.preventDefault();
        toggleMute();
      }
      if (e.code === 'ArrowLeft') {
        e.preventDefault();
        skip(-10);
      }
      if (e.code === 'ArrowRight') {
        e.preventDefault();
        skip(10);
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [togglePlayPause, toggleFullscreen, toggleMute, skip]);

  // 🔹 Handle Protection Click
  const handleProtectionClick = useCallback((e) => {
    e.preventDefault();
    e.stopPropagation();
    
    if (e.type === 'contextmenu') {
      showSecurityAlert("❌ النسخ والتحديد غير مسموح به");
      return false;
    }
    
    return false;
  }, []);

  const handleDragStart = useCallback((e) => {
    e.preventDefault();
    return false;
  }, []);

  const handleIframeError = useCallback(() => {
    setHasError(true);
    setVideoReady(false);
    if (onError) onError();
    showSecurityAlert("❌ حدث خطأ في تحميل الفيديو");
  }, [onError]);

  const handleIframeLoad = useCallback(() => {
    setVideoReady(true);
    setHasError(false);
    console.log("Video iframe loaded successfully");
    
    setTimeout(() => {
      try {
        if (iframeRef.current && iframeRef.current.contentWindow) {
          iframeRef.current.contentWindow.postMessage(
            JSON.stringify({
              event: "command",
              func: "getDuration",
              args: "",
              id: 7
            }),
            '*'
          );
          
          iframeRef.current.contentWindow.postMessage(
            JSON.stringify({
              event: "listening",
              id: 8,
              channel: "infoDelivery"
            }),
            '*'
          );
        }
      } catch (e) {
        console.log("Cannot request video info from iframe");
      }
    }, 2000);
  }, []);

  const secureUrl = getSecureVideoUrl(url);

  if (!url || hasError) {
    return (
      <div className="no-video-state">
        <div className="no-video-content">
          <div className="no-video-icon">🎬</div>
          <h3>لا يوجد فيديو متاح</h3>
          <p>يبدو أن الفيديو غير متوفر حالياً</p>
        </div>
      </div>
    );
  }

  const progressPercentage = duration > 0 ? (currentTime / duration) * 100 : 0;
  
  const getPercentageColor = (percentage) => {
    if (percentage >= 50) return '#4CAF50';
    if (percentage >= 25) return '#FF9800';
    return '#F44336';
  };

  return (
    <div className="secure-video-wrapper">
      {/* 1. حاوية الفيديو الأصلية */}
      <div 
        ref={videoContainerRef}
        className="video-protected-container"
        onContextMenu={handleProtectionClick}
        onDragStart={handleDragStart}
        onMouseDown={handleProtectionClick}
        onTouchStart={handleProtectionClick}
        onClick={(e) => {
          if (!e.target.closest('.yt-player-controls')) {
            handleProtectionClick(e);
          }
        }}
      >
{/* ضفنا دالة التشغيل والإيقاف عشان الطالب يقدر يدوس على الشاشة نفسها */}
<div className="protection-overlay" onClick={togglePlayPause}></div>
        <div className="protection-watermark">
          <span className="watermark-text">محتوى محمي</span>
          <span className="watermark-icon">🛡️</span>
        </div>
        
        <div className="video-iframe-container">
          <iframe
            ref={iframeRef}
            title={title || "المحاضرة التعليمية"}
            src={secureUrl}
            width="100%"
            height="100%"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            sandbox="allow-same-origin allow-scripts allow-popups"
            referrerPolicy="strict-origin-when-cross-origin"
            loading="lazy"
            className="protected-video-iframe"
            onError={handleIframeError}
            onLoad={handleIframeLoad}
          />
        </div>

        {/* 2. شريط تحكم يوتيوب (الجديد) - يظهر أسفل الفيديو مباشرة */}
        <div className="yt-player-controls">
          {/* شريط التقدم (Timeline) */}
          <div 
            ref={timelineRef}
            className="yt-timeline-container"
            onClick={handleTimelineClick}
            onMouseDown={handleTimelineMouseDown}
          >
            <div className="yt-timeline-bg"></div>
            <div className="yt-timeline-progress" style={{ width: `${progressPercentage}%` }}></div>
            <div className="yt-timeline-thumb" style={{ left: `${progressPercentage}%` }}></div>
          </div>

          {/* أزرار التحكم */}
          <div className="yt-controls-row">
            <div className="yt-controls-left">
              <button className="yt-btn" onClick={() => skip(-10)} title="رجوع 10 ثواني" disabled={!videoReady}>
                <ReplayIcon />
              </button>
              <button className="yt-btn yt-play-btn" onClick={togglePlayPause} title={isPlaying ? "إيقاف مؤقت" : "تشغيل"} disabled={!videoReady}>
                {isPlaying ? <PauseIcon /> : <PlayIcon />}
              </button>
              <button className="yt-btn" onClick={() => skip(10)} title="تقديم 10 ثواني" disabled={!videoReady}>
                <SkipNextIcon />
              </button>
              <button className="yt-btn" onClick={toggleMute} title={isMuted ? "تشغيل الصوت" : "كتم الصوت"} disabled={!videoReady}>
                {isMuted ? <VolumeOffIcon /> : <VolumeUpIcon />}
              </button>
              <div className="yt-time-display">
                <span>{formatTime(currentTime)}</span>
                <span className="yt-time-separator">/</span>
                <span>{isLoadingDuration ? '...' : formatTime(duration)}</span>
              </div>
            </div>

            <div className="yt-controls-right">
              <button className="yt-btn yt-speed-btn" onClick={changeSpeed} title="سرعة التشغيل" disabled={!videoReady}>
                {playbackRate}x
              </button>
              <button className="yt-btn" onClick={toggleFullscreen} title={isFullscreen ? "تصغير الشاشة" : "ملء الشاشة"} disabled={!videoReady}>
                {isFullscreen ? <ExitFullscreenIcon /> : <FullscreenIcon />}
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* 3. إحصائيات الطالب وتتبع التقدم (مفصول لعدم التشتيت) */}
      <div className="student-stats-dashboard">
        <div className="dashboard-header">
          <h4>📊 تقدمك في هذه المحاضرة</h4>
          <button 
            className="save-progress-btn"
            onClick={async () => {
              try {
                await saveWatchedPercentage(watchedPercentage);
                const videoId = localStorage.getItem('video_id');
                if (videoId) {
                  await sendProgressToAPI(videoId, watchedPercentage);
                }
                showSecurityAlert(`💾 تم حفظ تقدمك بنجاح: ${watchedPercentage.toFixed(1)}%`);
              } catch (error) {
                showSecurityAlert("❌ حدث خطأ أثناء الحفظ");
              }
            }}
            disabled={!videoReady || isLoadingProgress}
          >
            💾 حفظ تقدمي الآن
          </button>
        </div>

        <div className="stats-cards-grid">
          <div className="stat-card">
            <span className="stat-card-title">نسبة المشاهدة الحالية</span>
            <span className="stat-card-value" style={{ color: getPercentageColor(watchedPercentage) }}>
              {watchedPercentage.toFixed(1)}%
            </span>
          </div>
          <div className="stat-card">
            <span className="stat-card-title">أعلى نسبة وصلتلها</span>
            <span className="stat-card-value" style={{ color: getPercentageColor(highestWatchedPercentage) }}>
              {highestWatchedPercentage.toFixed(1)}%
            </span>
          </div>
          <div className="stat-card">
            <span className="stat-card-title">حالة التتبع</span>
            <span className="stat-card-value tracking-status" style={{ color: isWatching ? '#28a745' : '#6c757d' }}>
              {isWatching ? '🟢 جاري التتبع' : '⏸️ متوقف'}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

// 🔹 Resource Card Component
const ResourceCard = ({ icon: Icon, title, description, buttonLabel, href, onClick, disabled = false, buttonType = "default" }) => {
  const navigate = useNavigate();
  
  const handleClick = (e) => {
    if (disabled) {
      e.preventDefault();
      showSecurityAlert("هذا المورد غير متاح حالياً");
      return;
    }
    
    if (onClick) {
      onClick(e);
    } else if (href) {
      navigate(href);
    }
  };

  return (
    <div className={`resource-card ${disabled ? 'disabled' : ''}`}>
      <div className="card-header">
        <div className="card-icon">
          <Icon />
        </div>
        <div className="card-title">
          <h3>{title}</h3>
          <p>{description}</p>
        </div>
      </div>
      <button
        className={`resource-btn ${buttonType} ${disabled ? 'disabled-btn' : ''}`}
        onClick={handleClick}
        disabled={disabled}
      >
        {buttonType === "quiz" && <QuizIcon />}
        {buttonType === "pdf" && <PDFIcon />}
        {buttonType === "assignment" && <AssignmentIcon />}
        <span>{buttonLabel}</span>
      </button>
    </div>
  );
};

// 🔴 إضافة darkMode كـ Prop في الكومبوننت الرئيسي
// 🔹 Main Video Component
export default function Video({ darkMode }) {
  const [loading, setLoading] = useState(true);
  const [menuOpen, setMenuOpen] = useState(false);
  const [videoData, setVideoData] = useState({
    id:"",
    url: "",
    title: "فيديو المحاضرة",
    description: "لا يوجد وصف متاح"
  });
  const [lessonTitle, setLessonTitle] = useState("المحاضرة التعليمية");
  const [quizUrl, setQuizUrl] = useState("");
  const [fetchErrors, setFetchErrors] = useState({
    video: false,
    quiz: false,
    lesson: false
  });

  const navigate = useNavigate();

  // 🔹 Security Protection
  useEffect(() => {
    const handleContextMenu = (e) => {
      const target = e.target;
      if (target && target.closest && typeof target.closest === 'function') {
        const videoArea = target.closest('.video-protected-container, .protected-video-iframe');
        if (videoArea) {
          e.preventDefault();
          showSecurityAlert("❌ النسخ والتحديد غير مسموح به");
          return false;
        }
      }
      return true;
    };

    const handleSelectStart = (e) => {
      const target = e.target;
      if (target && target.closest && typeof target.closest === 'function') {
        const videoArea = target.closest('.video-protected-container');
        if (videoArea) {
          e.preventDefault();
          return false;
        }
      }
      return true;
    };

    document.addEventListener('contextmenu', handleContextMenu);
    document.addEventListener('selectstart', handleSelectStart);

    return () => {
      document.removeEventListener('contextmenu', handleContextMenu);
      document.removeEventListener('selectstart', handleSelectStart);
    };
  }, []);

  // 🔹 Fetch Data
  useEffect(() => {
    let isMounted = true;

    const fetchData = async () => {
      try {
        const token = localStorage.getItem("authToken");
        const lessonId = localStorage.getItem("lesson_id");

        if (!token || !lessonId) {
          navigate("/login");
          return;
        }

        const headers = { 
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json'
        };

        // Fetch Lesson Info
        try {
          const lessonRes = await axios.get(
            `https://leader-acadmy.hwnix.com/api/lessons/${lessonId}`,
            { headers }
          );
          
          if (isMounted && lessonRes.data) {
            setLessonTitle(lessonRes.data.title || "المحاضرة التعليمية");
            setFetchErrors(prev => ({ ...prev, lesson: false }));
          }
        } catch (lessonError) {
          console.log("Could not fetch lesson title");
          if (isMounted) {
            setFetchErrors(prev => ({ ...prev, lesson: true }));
          }
        }

        // Fetch Video Data
        try {
          const videoRes = await axios.get(
            `https://leader-acadmy.hwnix.com/api/videos/lesson/${lessonId}`,
            { headers }
          );

          if (isMounted && videoRes.data?.length > 0) {
            const video = videoRes.data[0];
            setVideoData({
              id: video.id ,
              url: video.url || "",
              title: video.title || "فيديو المحاضرة",
              description: video.description || "لا يوجد وصف متاح",
            });
            
            localStorage.setItem('video_id', video.id);

            setFetchErrors(prev => ({ ...prev, video: false }));
          } else {
            if (isMounted) {
              setFetchErrors(prev => ({ ...prev, video: true }));
            }
          }
        } catch (videoError) {
          console.log("Could not fetch video data:", videoError);
          if (isMounted) {
            setFetchErrors(prev => ({ ...prev, video: true }));
          }
        }

        // Fetch Quiz Data
        try {
          const quizRes = await axios.get(
            `https://leader-acadmy.hwnix.com/api/mcqs/lesson/${lessonId}`,
            { headers }
          );

          if (isMounted && quizRes.data?.mcqs?.length > 0) {
            setQuizUrl(quizRes.data.mcqs[0].url || "");
            setFetchErrors(prev => ({ ...prev, quiz: false }));
          } else {
            setQuizUrl("");
            setFetchErrors(prev => ({ ...prev, quiz: true }));
          }
        } catch (quizError) {
          console.log("No quiz available for this lesson:", quizError);
          if (isMounted) {
            setQuizUrl("");
            setFetchErrors(prev => ({ ...prev, quiz: true }));
          }
        }

      } catch (error) {
        console.error("❌ Error fetching data:", error);
        if (isMounted) {
          showSecurityAlert("حدث خطأ في تحميل المحتوى");
        }
      } finally {
        if (isMounted) {
          setTimeout(() => {
            setLoading(false);
          }, 500);
        }
      }
    };

    fetchData();

    return () => {
      isMounted = false;
    };
  }, [navigate]);

  // 🔹 Handle Logout
  const handleLogout = async () => {
    try {
      const token = localStorage.getItem("authToken");
      if (token) {
        await axios.post(
          "https://leader-acadmy.hwnix.com/api/logout",
          {},
          { headers: { Authorization: `Bearer ${token}` } }
        );
      }
    } catch (error) {
      console.error("Logout Failed:", error);
    } finally {
      localStorage.clear();
      navigate("/Login");
    }
  };

  // 🔹 Render Loading State
  if (loading) {
    return (
      <div className="video-page loading-page">
        <div className="loading-container">
          <div className="loading-spinner-large"></div>
          <p>جاري تحميل المحتوى...</p>
        </div>
      </div>
    );
  }

  return (
    <ErrorBoundary>
      {/* 🔴 تفعيل كلاس الـ Dark Mode لو الخاصية مفعلة */}
      <div className={`video-page student-page ${darkMode ? 'dark-mode' : ''}`}>
        <div className="security-background">
          <div className="security-pattern"></div>
        </div>

        <header className="student-header">
          <div className="header-container">
            <div className="header-left">
              <div className="brand-info">
                <div className="brand-logo">🎓</div>
                <div className="brand-text">
                  {lessonTitle && (
                    <p className="current-lesson">{lessonTitle}</p>
                  )}
                </div>
              </div>
            </div>

            <div className="header-right">
              <div className="security-indicator">
                <span className="security-icon">🛡️</span>
                <span className="security-text">محتوى آمن</span>
              </div>
            </div>
          </div>
        </header>

        <div 
          className={`menu-overlay ${menuOpen ? 'active' : ''}`} 
          onClick={() => setMenuOpen(false)} 
        />
        
        <nav className={`student-menu ${menuOpen ? 'open' : ''}`}>
          <div className="menu-header">
            <h3>القائمة الرئيسية</h3>
            <button 
              className="menu-close" 
              onClick={() => setMenuOpen(false)}
              aria-label="إغلاق القائمة"
            >
              <CloseIcon />
            </button>
          </div>
          
          <div className="menu-items">
            <button 
              className="menu-item" 
              onClick={() => { navigate("/"); setMenuOpen(false); }}
            >
              <HomeIcon />
              <span>الرئيسية</span>
            </button>
            
            <button 
              className="menu-item" 
              onClick={() => { navigate("/ProfileCard"); setMenuOpen(false); }}
            >
              <LessonIcon />
              <span>المحاضرات</span>
            </button>
            
            <button 
              className="menu-item logout" 
              onClick={handleLogout}
            >
              <span className="logout-icon">🚪</span>
              <span>تسجيل الخروج</span>
            </button>
          </div>
        </nav>

        <main className="student-main">
          <section className="video-display-section">
            <div className="section-header">
              <h2 className="section-title">
                <span className="title-icon">🎬</span>
                الفيديو التعليمي
                <span className="security-badge">🛡️ محمي</span>
              </h2>
              <div className="video-warning">
                <span className="warning-icon">⚠️</span>
                <span>النسخ والتحديد محظور</span>
              </div>
            </div>

            <div className="video-display-container">
              {fetchErrors.video ? (
                <div className="video-error-state">
                  <div className="error-icon">⚠️</div>
                  <h3>لا يوجد فيديو متاح</h3>
                  <p>يبدو أن الفيديو غير متوفر حالياً</p>
                  <button 
                    className="retry-btn"
                    onClick={() => window.location.reload()}
                  >
                    إعادة المحاولة
                  </button>
                </div>
              ) : (
                <SecureVideoPlayer 
                  url={videoData.url} 
                  title={videoData.title}
                  onError={() => setFetchErrors(prev => ({ ...prev, video: true }))}
                />
              )}
            </div>

            {!fetchErrors.video && videoData.url && (
              <div className="video-info-card">
                <h3 className="video-title">{videoData.title}</h3>
                <p className="video-description">{videoData.description}</p>
                <div className="video-meta">
                  <span className="meta-item">
                    <span className="meta-icon">🎬</span>
                    تحكم خارجي آمن
                  </span>
                  <span className="meta-item">
                    <span className="meta-icon">🔒</span>
                    حماية كاملة ضد النسخ
                  </span>
                  <span className="meta-item">
                    <span className="meta-icon">📱</span>
                    متوافق مع جميع الشاشات
                  </span>
                </div>
              </div>
            )}
          </section>

          <section className="resources-section">
            <h2 className="section-title">
              <span className="title-icon">📚</span>
              المصادر التعليمية
            </h2>
            
            <div className="resources-grid">
              <ResourceCard
                icon={AssignmentIcon}
                title="الواجبات"
                description="الواجبات المنزلية"
                buttonLabel="عرض الواجبات"
                href="/AssignmentsPage"
                buttonType="assignment"
              />

              <ResourceCard
                icon={PDFIcon}
                title="الملازم"
                description="الملفات التعليمية"
                buttonLabel="عرض الملازم"
                href="/PdfList"
                buttonType="pdf"
              />

              <div className="resource-card">
                <div className="card-header">
                  <div className="card-icon">
                    <QuizIcon />
                  </div>
                  <div className="card-title">
                    <h3>الاختبارات</h3>
                    <p>اختبارات تفاعلية</p>
                  </div>
                </div>
                
                {quizUrl && quizUrl.trim() ? (
                  <a 
                    href={quizUrl} 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="resource-btn quiz-btn"
                  >
                    <QuizIcon />
                    <span>بدء الاختبار</span>
                  </a>
                ) : (
                  <button 
                    className="resource-btn disabled-btn"
                    onClick={() => showSecurityAlert("لا يوجد اختبار متاح حالياً")}
                  >
                    <span>غير متاح</span>
                  </button>
                )}
              </div>
            </div>
          </section>

          <section className="chat-section">
            <div className="section-header">
              <h2 className="section-title">
                <span className="title-icon">💬</span>
                التواصل مع المعلم
              </h2>
            </div>
            <div className="chat-container">
              <ErrorBoundary>
                <ChatComponent />
              </ErrorBoundary>
            </div>
          </section>
        </main>

      </div>
    </ErrorBoundary>
  );
}